import gql from "graphql-tag"

const GET_CAMPAIGN = gql`
  query getCampaignGroup($id: ID!) {
    getCampaign(id: $id) {
        id
        campaignGroupId
        name
        priceRule {
          type
          percentage
          percentageDecimals
          monies {
            key
            value
          }
        }
        productVariantRules {
          tagLogic
        }
        roundingRules {
          defaultRule {
            roundUp
            roundDown
            targets
          }
          marketRules {
            key
            value {
              roundUp
              roundDown
              targets
            }
          }
        }
        storeMarkets {
          key
          value
        }
        startDate
        endDate
        created
        updated
      }
    }
`

export default GET_CAMPAIGN
